// @flow

import unifizeUser from "./index";
import NameOrEmail from "src/components/user/NameOrEmail";

export default unifizeUser(NameOrEmail);
